import { render, staticRenderFns } from "./u-tabs-dot.vue?vue&type=template&id=417eeef0&scoped=true"
import script from "./u-tabs-dot.vue?vue&type=script&lang=js"
export * from "./u-tabs-dot.vue?vue&type=script&lang=js"
import style0 from "./u-tabs-dot.vue?vue&type=style&index=0&id=417eeef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417eeef0",
  null
  
)

export default component.exports